import { Component } from "react";
import { Button, Container, Form, OverlayTrigger, Stack, Tooltip } from "react-bootstrap";
import { TemplateItem } from "./templateItem";
import { v4 as uuid } from "uuid";

const getDefaultQuestion = () => ({
    id: Date.now(),
    question: '',
    questionType: 0,
    answerSet: [''],
})

export class TemplateBuilder extends Component {
    constructor(props) {
        super(props)
        if (props.viewOnlyMode) {
            this.state = {
                ...props.templateData,
                privateTemplate: props.templateData.domain === 'District-private',
            }
        } else if (props.templateData && props.templateData.questions) {
            const idQuestions = props.templateData.questions.map((question) => ({...question, id: uuid()}))
            this.state = {
                ...props.templateData,
                questions: idQuestions,
                templateName: `${props.templateData.templateName} Copy`,
                privateTemplate: props.templateData.domain === 'District-private',
            }
        } else {
            this.state = {
                templateName: '',
                questions: [
                    {...getDefaultQuestion()}
                ],
                privateTemplate: false,
            }
        }
        this.apiManager = props.apiManager;
    }

    handleTemplateNameChange = (e) => {
        this.setState({templateName: e.target.value})
    }

    handleTemplateItemChange = (idx, item) => {
        let newTemplateSet = [...this.state.questions]
        newTemplateSet[idx] = item
        this.setState({questions: newTemplateSet})
    }

    handleTemplateItemDelete = (idx) => {
        let newTemplateSet = [...this.state.questions]
        newTemplateSet.splice(idx, 1)
        this.setState({questions: newTemplateSet})
    }

    addNewQuestion() {
        this.setState({questions: [...this.state.questions, {...getDefaultQuestion()}]})
    }

    saveTemplate = async () => {
        const cleanedQuestions = this.state.questions.map(({id, ...rest}) => rest)
        const response = await this.apiManager.addTemplate({
            ...this.state,
            questions: cleanedQuestions,
        })
        if (response) {
            this.props.onTemplateSave()
            this.setState({
                templateName: '',
                questions: [
                    {...getDefaultQuestion()}
                ]
            })
        }
    }

    handleTemplatePrivacyChange = (e) => {
        this.setState({privateTemplate: e.target.checked})
    }

    renderTooltip = (props) => (
        <Tooltip id="info-tooltip" {...props}>
          Private templates will only be available to district-level users. School-level users will not have access to them.
        </Tooltip>
    )

    render() {
        return (
            <Container>
                <Form.Control readOnly={!!this.props.viewOnlyMode} className="mb-2" type="text" value={this.state.templateName} placeholder="Template name..." onChange={this.handleTemplateNameChange}/>
                {this.props.domain === 'District' &&
                    <Form.Check
                        type="switch"
                        className="mb-3"
                        disabled={!!this.props.viewOnlyMode}
                        checked={this.state.privateTemplate}
                        onChange={this.handleTemplatePrivacyChange}
                        label={<>
                            Private&nbsp;
                            <OverlayTrigger
                                placement="top"
                                delay={{show: 100, hide: 200}}
                                overlay={this.renderTooltip}
                            >
                                <i class="bi bi-info-circle"></i>
                            </OverlayTrigger>
                        </>}
                    />
                }
                {this.state.questions.map((item, idx) => {
                    return <TemplateItem 
                            numQuestions={this.state.questions.length}
                            viewOnlyMode={this.props.viewOnlyMode}
                            key={item.id || idx} templateItemData={item}
                            questionIdx={idx}
                            handleChange={this.handleTemplateItemChange}
                            handleQuestionDelete={() => this.handleTemplateItemDelete(idx)}
                            />
                })}
                {!this.props.viewOnlyMode &&
                    <Stack gap={3} direction="horizontal" >
                        <Button
                            variant="secondary"
                            disabled={!this.state.questions[this.state.questions.length - 1].question}
                            onClick={() => this.addNewQuestion()}>
                                Add Question
                        </Button>
                        <Button
                            disabled={!this.state.questions[this.state.questions.length - 1].question || !this.state.templateName}
                            onClick={this.saveTemplate}
                        >
                            Save Template
                        </Button>
                    </Stack>
                }
            </Container>
        )
    }
}